<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file EventTickets.vue is part of event_pass_client.dev.              -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - EventTickets.vue can not be copied and/or distributed                     -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 28/02/2018-->
<!--//Time: 09:39-->

<template>
    <div>
        <div v-if="car_park_tickets.length > 0">
            <AddonTicketModal
                    :tickets="addons"
                    :add_ticket_url="add_ticket_url"
                    :display="display_modal"
                    @modal_close="modalClosed"
                    :map_lat="map_lat"
                    :map_lng="map_lng"
            >
            </AddonTicketModal>
            <AddonTickets
                    :tickets="addons"
                    :add_ticket_url="add_ticket_url"
                    :map_lat="map_lat"
                    :map_lng="map_lng"
            />
            <car-park-tickets
                    :page_event_id="page_event_id"
                    :payment_intent_request="payment_intent_request"
                    :stripe_use="stripe_use"
                    :tickets_loaded="loading"
                    :event_details="event_details"
                    :show_map="show_map"
                    :car_park_tickets="car_park_tickets"
                    :show_remaining="show_remaining"
                    :images_url="images_url"
                    :add_ticket_url="add_ticket_url"
                    :pay_with_card_url="pay_with_card_url"
                    :my_account_url="my_account_url"
                    :start_date="start_date"
                    :user="user"
                    :map_lat="map_lat"
                    :map_lng="map_lng"
            />
        </div>
    </div>
</template>

<script>
    import {$basketController} from '../../../config/config.js';
    import {_} from 'underscore';

    window.Vue.component('AddonTicketModal', require('../../tickets/AddonTicketModal'));
    window.Vue.component('AddonTickets', require('../../tickets/AddonTickets'));
    window.Vue.component('car-park-tickets', require('../../tickets/CarParkTickets.vue'));

    export default {
        name: "event-tickets",
        components: {},
        props: {
            map_lat: {
                type: Number,
                default: null
            },
            map_lng: {
                type: Number,
                default: null
            },
            page_event_id: {
                type: String,
                default: 'event-page-id'
            },
            /**
             * @property data
             * @namespace
             * */
            route_url: Object,
            stripe_use: {
                type: Object,
                default: null
            },
            payment_intent_request: {
                type: String,
                default: null
            },
            event_id: Number | String,
            event_details: Object,
            images_url: Object,
            add_ticket_url: Object,
            pay_with_card_url: Object,
            my_account_url: Object,
            show_remaining: Boolean,
            show_map: Boolean,
            user: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        created() {
            console.log(this.user);
        },
        destroyed() {
        },
        mounted() {
            let self = this;
            self.readEventTickets();
            $basketController
                .$on('read_basket', function (ticket_id) {
                    let ticketMatch = false;
                    let hasAddon = false;
                    for (let i = 0; i < self.car_park_tickets.length; i++) {
                        let ticket = self.car_park_tickets[i];

                        // console.log(ticket, ticket.id, ticket_id, ticket.id === ticket_id);
                        // does the ticket actually belong in this event? ticket.id === ticket_id means its in the list
                        if (ticket.ticket_type === 'addon') {
                            hasAddon = true;
                        }
                        if (ticketMatch === false) {
                            if (ticket.ticket_type !== 'addon' && ticket.id === ticket_id) {
                                ticketMatch = true;
                            }
                        }

                    }
                    if (hasAddon && ticketMatch) {
                        self.display_modal = true;
                    }
                });
        },
        data() {
            return {
                display_modal: false,
                loading: false,
                entity_types: Array,
                car_park_tickets: Array,
                door_tickets: Array,
                bus_tickets: Array,
                addons: [],
                start_date: Object
            }
        },
        methods: {
            modalClosed() {
                let self = this;

                self.display_modal = false;
                // console.log('modal closed')
            },
            readEventTickets() {
                let self = this;
                self.loading = true;

                axios.post(this.route_url.data, {
                    event_id: this.event_id
                })
                    .then(function (response) {
                        if (response.data.success) {
                            self.loading = false;
                            self.compileEntityTypes(response.data.entity_types);
                            self.start_date = response.data.start_date;
                        }
                    })
                    .catch(function (e) {
                        console.error('e', e);
                    });
            },
            log(ref, data) {
                console.log(ref, data);
            },
            /**
             * The response is an array of entity types. to get the type. drill into one of the records inside
             * and assign that type to the appropriate dataset for passing to that compatible component
             * @param entity_types
             */
            compileEntityTypes(entity_types) {
                let self = this,
                    cars = new Array()
                    // ,
                    // buses = Array,
                    // doors = Array
                ;
                self.entity_types = _.toArray(entity_types);

                for (let i = 0; i < self.entity_types.length; i++) {
                    /**
                     * we only need to get thte first record because all others are of the same type
                     */
                    let entity_type = _.first(self.entity_types[i]).entity.entity_data.entity_type.slug,
                        entity_types = self.entity_types[i]
                    ;

                    /**
                     * Now we have to iterate through each ticket assigning to the correct type for display
                     */
                    for (let j = 0; j < entity_types.length; j++) {
                        let ticket = entity_types[j];

                        switch (entity_type) {
                            case 'car-park':
                                Array.prototype.push.apply(cars, [ticket]);
                                break;
                            case 'bus':
                                Array.prototype.push.apply(cars, [ticket]);
                                break;
                            case 'door-ticket':
                                Array.prototype.push.apply(cars, [ticket]);
                                break;
                            case 'addon':
                                self.addons = self.entity_types[i];
                                break;
                        }

                    }

                }
                self.car_park_tickets = cars;
            }
        },
        computed: {}
    }
</script>





// WEBPACK FOOTER //
// resources/assets/js/components/pages/events/EventTickets.vue